// Types.ts
export const REDUCER_NAME="SuperAdminSlice";
export interface iGenericResponse {
  success: boolean;
  message: string;
  data?: any; // adjust based on API response
}

export interface iStateMessage {
  loading: boolean;
  loadingList:boolean;
  error: string | null;
  message: string | null;
}
export interface iAddProFormInvoiceDetail {
  inspection: string;
  insurance: string;
  freightTransportation: string;
  gstTax: string;
  termsOfPayment: string;
  deliverySchedule: string;
  packingCharges: string;
  priceBasis: string;
  id: string;
  vendorId: string;
  purchaseOrderNumber: string | null;
  productName: string | null;
  itemCode: string | null;
  hsnCode: string | null;
  uom: string | null;
  quantity: string;
  rate: string;
  discount: string;
  taxType: string | null;
  taxRate: string;
  warehouse: string | null;
  batchNumber: string | null;
  expiryDate: string | null;
  description: string | null;
  remarks: string | null;
  companyName: string | null;
  companyAddress: string | null;
  cityPincode: string | null;
  phone: string | null;
  email: string | null;
  gstin: string | null;
  orderNo: string | null;
  date: string | null;
  amendmentDetails: string | null;
  reference: string | null;
  poValidity: string | null;
  supplierName: string | null;
  supplierAddress: string | null;
  supplierGstin: string | null;
  deliveryCompanyName: string | null;
  deliveryAddress: string | null;
  deliveryCityPincode: string | null;
  preparedBy: string | null;
  preparedDate: string | null;
  approvedBy: string | null;
  created_at: string;
  updated_at: string | null;
  notes:string | null;

}

export interface ProFormaInvoce extends iStateMessage {
  detail: any | null; 
  list: any | null;// adjust type based on API response
  loadingDataList:any | null;
  dataList:any | null;
}
